import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  clientVersion: '1.81.0-26-g3e73e17e',
  logLevel: NgxLoggerLevel.INFO,
  API_HOST: 'https://' + window.location.hostname
};
